class EventFilter {
  constructor(element) {
    this.module = element;
    this.filter = [];
    this.list = this.module.querySelector(".events-list__list");
    this.cards = this.list.querySelectorAll(".card-event");
    this.filterContainer = this.module.querySelector(".events-list__filter");
    this.init();
  }

  init() {
    // Load filters from URL on page load
    this.loadFiltersFromURL();

    // Disable unused terms
    this.disableUnusedTerms();

    // Listen for changes to select elements
    this.listen();

    // Apply initial filters and scroll if any filters are active
    if (this.filter.length > 0) {
      this.filterCards();
      this.scrollToElement();
      document.querySelector(".events-list__filter-text").innerText =
        "Change filter";
    }
  }

  listen() {
    this.filterContainer.addEventListener("change", (ev) => {
      const taxonomy = ev.target.getAttribute("data-taxonomy");
      const value = ev.target.value;

      // Update the active filters
      this.updateFilter(taxonomy, value);

      // Update URL with current filters
      this.updateURL();

      // Show all cards initially, then apply filtering
      this.showAll();
      this.filterCards();

      if (this.activeFilter()) {
        if (window.innerWidth > 1024) {
          document.querySelector(".events-list__filter-text").innerText =
            "Filter";
          return;
        }
        document.querySelector(".events-list__filter-text").innerText =
          "Change filter";
      } else {
        document.querySelector(".events-list__filter-text").innerText =
          "Filter";
      }
    });
    // Mobile button handler
    this.mobileButtonListener();
  }

  activeFilter() {
    const selects = this.module.querySelectorAll(
      ".events-list__filter .dropdown__select"
    );
    let isActive = false;
    selects.forEach((select) => {
      if (select.value && select.value != "") {
        isActive = true;
        return;
      }
    });
    return isActive;
  }

  mobileButtonListener() {
    const button = this.module.querySelector(".events-list__filter-heading");
    const filterContainer = this.module.querySelector(".events-list__filter");
    button.addEventListener("click", () => {
      filterContainer.classList.toggle("events-list__filter--open");
    });

    const closeButton = this.module.querySelector(".events-list__close-filter");
    closeButton.addEventListener("click", () => {
      filterContainer.classList.remove("events-list__filter--open");
    });

    const showResults = this.module.querySelector(".events-list__show-results");
    showResults.addEventListener("click", () => {
      filterContainer.classList.remove("events-list__filter--open");
      document.querySelector(".events-list__list").scrollIntoView();
    });
  }

  loadFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Get all valid taxonomies from dropdowns
    const validTaxonomies = new Set();
    const selects = this.filterContainer.querySelectorAll(
      "select[data-taxonomy]"
    );
    selects.forEach((select) =>
      validTaxonomies.add(select.getAttribute("data-taxonomy"))
    );

    urlParams.forEach((value, taxonomy) => {
      if (validTaxonomies.has(taxonomy)) {
        // Only allow relevant taxonomies
        this.filter.push({ taxonomy, value });

        // Preselect the corresponding <select> element
        const select = this.filterContainer.querySelector(
          `select[data-taxonomy="${taxonomy}"]`
        );
        if (select) {
          select.value = value;
        }
      }
    });
  }

  updateFilter(taxonomy, value) {
    const existingFilter = this.filter.find(
      (filter) => filter.taxonomy === taxonomy
    );

    if (value === "") {
      // Remove filter if no value is selected
      this.filter = this.filter.filter(
        (filter) => filter.taxonomy !== taxonomy
      );
    } else if (existingFilter) {
      // Update the existing filter value
      existingFilter.value = value;
    } else {
      // Add new filter
      this.filter.push({ taxonomy, value });
    }
  }

  updateURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Remove only the taxonomy-related parameters
    this.filterContainer
      .querySelectorAll("select[data-taxonomy]")
      .forEach((select) => {
        urlParams.delete(select.getAttribute("data-taxonomy"));
      });

    // Add the active filters back
    this.filter.forEach(({ taxonomy, value }) => {
      urlParams.set(taxonomy, value);
    });

    const newURL = `${window.location.pathname}?${urlParams.toString()}`;
    history.replaceState(null, "", newURL); // Update the URL without reloading the page
  }

  showAll() {
    this.cards.forEach((card) => {
      card.style.display = ""; // Reset display style
    });
  }

  filterCards() {
    let hasVisibleCards = false; // Track if at least one card is visible

    this.cards.forEach((card) => {
      let hide = false;

      this.filter.forEach((entry) => {
        const cardValue = card.getAttribute(`data-${entry.taxonomy}`);
        const values = cardValue ? cardValue.split(",") : []; // Handle multiple values

        if (!values.includes(entry.value)) {
          hide = true;
        }
      });

      if (hide) {
        card.style.display = "none"; // Hide the card if it doesn't match
      } else {
        hasVisibleCards = true; // Found at least one visible card
      }
    });

    const noResultsElement = document.querySelector(".events-list__no-results");
    if (!hasVisibleCards) {
      noResultsElement.classList.remove("events-list__no-results--hidden");
    } else {
      noResultsElement.classList.add("events-list__no-results--hidden");
    }
  }

  scrollToElement() {
    this.module.scrollIntoView({ behavior: "smooth" });
  }

  disableUnusedTerms() {
    const terms = this.module.querySelectorAll("option");
    terms.forEach((term) => {
      const select = term.parentElement;
      const cards = this.module.querySelectorAll(".card-event");
      let showIt = false;
      cards.forEach((card) => {
        const attrValue = card.getAttribute(`data-${select.dataset.taxonomy}`);
        const terms = attrValue
          ? attrValue.split(",").map((term) => term.trim())
          : [];
        // If any card has a term that is in a select, show it.
        if (term.value == "" || terms.includes(term.value)) {
          showIt = true;
        }
      });
      if (!showIt) {
        term.setAttribute("disabled", true);
      }
    });
  }
}

export default EventFilter;
